import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import supabase from "../../supabase";
import CheckManager from "../clientBillDetails/checkManager";
import { Field, FormCard, FormGrid, SelectInput, TextInput } from "../../components/ui/form";

const DetailCashAdd = ({ onCashIdSelectedChange, onAmountToAddChange, onDescriptionChange, updateCashesAdd, setSelectedChecksNumbers, setChecks, cashIdSelected }) => {
  const [cashId, setCashId] = useState('');
  const [cashIdSelectedLocal, setCashIdSelectedLocal] = useState('');
  const [description, setDescription] = useState('');
  const [amountToAdd, setAmountToAdd] = useState('');
  const [cashes, setCashes] = useState([]);

  const isChequesSelected = cashIdSelected === '7';

  const handleAmountToAddChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+(\.\d{1,2})?$/.test(value)) {
      setAmountToAdd(value);
      onAmountToAddChange(value);
    } else {
      e.preventDefault();
    }
  };

  const handleChequesInputChange = (e) => {
    if (e.target?.id === 'cheques') {
      onAmountToAddChange(e.target.value || '0');
    }
  };

  const setPaymentMethodsForCheques = (updater) => {
    const result = typeof updater === 'function' ? updater({}) : updater;
    if (result?.cheques !== undefined) {
      onAmountToAddChange(String(result.cheques));
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescription(value);
    onDescriptionChange(value);
  };

  const fetchData = async () => {
    const { data, error } = await supabase.from('cash').select('*').order('cashId', {ascending: true});
    if (error) {
      console.error("Error al obtener los datos: ", error);
    }else{
      setCashes(data);
      updateCashesAdd(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCashIdChange = (e) => {
    const cashId = e.target.value;
    setCashIdSelectedLocal(cashId);
    onCashIdSelectedChange(cashId);
    if (cashId !== '7') {
      setChecks([]);
      onAmountToAddChange('');
    }
  };

  return (
    <FormCard
      title="Datos del ingreso"
      subtitle="Elegí la caja y cargá el monto. Si es cheques, se cargan uno por uno."
    >
      <FormGrid columns={3}>
        <Field label="Caja" required>
          <SelectInput
            id="cashIdSelected"
            value={cashIdSelected || cashIdSelectedLocal}
            onChange={handleCashIdChange}
            required
          >
            <option value="">Seleccionar caja</option>
            {Array.isArray(cashes) &&
              cashes.map((cash) => (
                <option key={cash.cashId} value={cash.cashId}>
                  {cash.description}
                </option>
              ))}
          </SelectInput>
        </Field>

        {!isChequesSelected && (
          <Field label="Monto" required hint="En pesos, con hasta dos decimales.">
            <TextInput
              type="number"
              id="amountToAdd"
              value={amountToAdd}
              min="0"
              step="0.01"
              numeric
              placeholder="0,00"
              onChange={handleAmountToAddChange}
              required
            />
          </Field>
        )}

        <Field
          label="Descripción"
          required={!isChequesSelected}
          span={isChequesSelected ? 2 : 1}
        >
          <TextInput
            type="text"
            id="description"
            value={description}
            onChange={handleDescriptionChange}
            placeholder={
              isChequesSelected ? "Ej: ingreso de cheque recibido" : "Motivo del ingreso"
            }
            required={!isChequesSelected}
          />
        </Field>
      </FormGrid>

      {isChequesSelected && (
        <Box sx={{ paddingTop: "4px" }}>
          <CheckManager
            setPaymentMethods={setPaymentMethodsForCheques}
            handleInputChange={handleChequesInputChange}
            setChecks={setChecks}
            autoAddFirstCheck
          />
        </Box>
      )}
    </FormCard>
  );
};

export default DetailCashAdd;
